import React, { useState } from 'react';
import { auth } from '../firebase';
import useRazorpayPayment from '../services/useRazorpayPayment';
import './FastTrackUpsellModal.css';

const FAST_TRACK_PLAN_ID = 'FAST_TRACK_7DAY';

const FEATURES = [
  '5 AI interviews',
  'Coding practice unlocked',
  'MCQ tests unlocked',
  'Full detailed reports',
];

/**
 * FastTrackUpsellModal — the single upsell surface for the Freemium
 * Conversion Funnel. Every locked button (Coding, MCQ, 2nd interview,
 * full report) opens this same popup instead of navigating to a
 * separate pricing page. Reuses the existing, unmodified Razorpay flow.
 */
export default function FastTrackUpsellModal({ open, onClose, onSuccess }) {
  const { initiatePayment, loading, error, setError } = useRazorpayPayment();
  const [done, setDone] = useState(false);

  if (!open) return null;

  const handleUnlock = async () => {
    const user = auth.currentUser;
    if (!user) {
      setError('Please log in to continue');
      return;
    }

    await initiatePayment({
      planType: FAST_TRACK_PLAN_ID,
      userEmail: user.email || '',
      userName: user.displayName || '',
      userPhone: user.phoneNumber || '',
      onSuccess: (response) => {
        setDone(true);
        if (onSuccess) onSuccess(response);
      },
      onFailure: (err) => {
        setError(err?.error || 'Payment failed. Please try again.');
      },
    });
  };

  return (
    <div className="ftm-backdrop" onClick={onClose}>
      <div className="ftm-modal" onClick={(e) => e.stopPropagation()}>
        <button className="ftm-close" onClick={onClose} aria-label="Close">×</button>

        {done ? (
          <div className="ftm-success">
            <span className="ftm-success-icon">✅</span>
            <h2>Unlocked!</h2>
            <p>Fast Track Practice is active. Refresh to see your unlocked features.</p>
            <button className="ftm-btn" onClick={onClose}>Continue</button>
          </div>
        ) : (
          <>
            <span className="ftm-badge">Fast Track Practice</span>
            <h2 className="ftm-price">₹299 <span>/ 7 days</span></h2>
            <ul className="ftm-features">
              {FEATURES.map((f) => (
                <li key={f}><span className="ftm-check">✓</span>{f}</li>
              ))}
            </ul>
            {error && <div className="ftm-error">{error}</div>}
            <button className="ftm-btn" disabled={loading} onClick={handleUnlock}>
              {loading ? 'Processing…' : 'Unlock Now — ₹299'}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
